import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const UpdateIcon = (props: SvgProps) => (
  <Svg
    width={64}
    height={65}
    fill="none"
    {...props}
  >
    <Path
      stroke="#3379BD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M10.666 32.5A21.334 21.334 0 0 1 50.48 21.833m-13.147 0h13.334V8.5m2.666 24A21.333 21.333 0 0 1 13.52 43.167m13.146 0H13.333V56.5"
    />
  </Svg>
);
export default UpdateIcon;
